export default __webpack_public_path__ + "static/media/imgPrize2.412c000a.png";